import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "send",
  "use": "send-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"send\"><path d=\"M6.401 8.57l5.85-5.85-9.75 3.9 3.9 1.95zm6.879-4.822l-5.85 5.85L9.38 13.5l3.9-9.75zM.402 7.197a.727.727 0 01.055-1.326L15.001.054a.727.727 0 01.945.945L10.13 15.543a.727.727 0 01-1.326.055l-2.8-5.6L.402 7.196z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol